import { type Organization } from "@overmap-ai/common"
import { HttpMethod, OrganizationService as OvermapOrganizationService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export interface OrganizationInviteResult {
	/**
	 * Set if the organization requires single sign-on.
	 * The invitee then joins by signing in instead of with an emailed code.
	 */
	message?: string
}

export class OrganizationService extends OvermapOrganizationService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL

	/**
	 * Sends the same request as `invite`, but right away instead of through the offline queue.
	 * It returns the API's response, which the invite dialog shows, so it cannot wait until the user is back online.
	 */
	async inviteWithResult(
		organizationUuid: Organization["uuid"],
		email: string,
	): Promise<OrganizationInviteResult | undefined> {
		return this.performRequest({
			method: HttpMethod.POST,
			url: `${this.url}/${organizationUuid}/invite/${encodeURIComponent(email)}/`,
		})
	}
}
